import { boronClient } from "../../../../api";
import { useBoronMutation } from "../../../../hooks/http/useBoronMutation";
import { useOperatorsCacheUpdater } from "../../useFetchOperators";

export const useDeleteInvite = () => {
  const { removeInvitingOperator } = useOperatorsCacheUpdater();

  return useBoronMutation(
    async ({ sectionId, inviteId }: { sectionId: string; inviteId: string }) =>
      await boronClient.DELETE(
        "/api/v1/sections/{section_id}/operators/invitation/{invitation_hashid}",
        {
          params: {
            path: {
              section_id: sectionId,
              invitation_hashid: inviteId,
            },
          },
        },
      ),
    {
      onSuccess: (_, { sectionId, inviteId }) => {
        removeInvitingOperator(sectionId, inviteId);
      },
    },
  );
};
